// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BrideImage_brideGroup__TJqSR {
  display: flex;
  justify-content: start;
  align-items: center;
}
.BrideImage_brideGroup__TJqSR figure {
  border-radius: 500px;
  aspect-ratio: 1/1;
  border: 1px solid var(--border);
  overflow: hidden;
  width: 64px;
  height: 64px;
  margin-left: -17px;
}
.BrideImage_brideGroup__TJqSR figure:first-child {
  margin-left: 0;
}
.BrideImage_brideGroup__TJqSR figure img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}`, "",{"version":3,"sources":["webpack://./src/components/atoms/BrideImage/BrideImage.module.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;AACD;AACC;EACC,oBAAA;EACA,iBAAA;EACA,+BAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AACF;AACE;EACC,cAAA;AACH;AAEE;EACC,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;AAAH","sourcesContent":[".brideGroup {\r\n\tdisplay: flex;\r\n\tjustify-content: start;\r\n\talign-items: center;\r\n\r\n\tfigure {\r\n\t\tborder-radius: 500px;\r\n\t\taspect-ratio: 1 / 1;\r\n\t\tborder: 1px solid var(--border);\r\n\t\toverflow: hidden;\r\n\t\twidth: 64px;\r\n\t\theight: 64px;\r\n\t\tmargin-left: -17px;\r\n\r\n\t\t&:first-child {\r\n\t\t\tmargin-left: 0;\r\n\t\t}\r\n\r\n\t\timg {\r\n\t\t\twidth: 100%;\r\n\t\t\theight: 100%;\r\n\t\t\tobject-fit: cover;\r\n\t\t\tobject-position: center;\r\n\t\t}\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"brideGroup": `BrideImage_brideGroup__TJqSR`
};
export default ___CSS_LOADER_EXPORT___;
